import { render, staticRenderFns } from "./StoreAssetBox.vue?vue&type=template&id=2510479c&scoped=true&"
import script from "./StoreAssetBox.vue?vue&type=script&lang=js&"
export * from "./StoreAssetBox.vue?vue&type=script&lang=js&"
import style0 from "./StoreAssetBox.vue?vue&type=style&index=0&id=2510479c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2510479c",
  null
  
)

export default component.exports